module.exports = __webpack_public_path__ + "img/RUB.c01c2ae4.svg";